// extracted by mini-css-extract-plugin
module.exports =  {"root":"Mh85KbMV1oCHVmf2A86g","content":"qI4CV1w8BFwAOkxDwuQq","logo":"BV7PHsjlUDQyGHMof5n7"};